import { Customer, Identity } from './customer.model';
import { Channel } from './channel.model';

export interface Registration extends Identity, Customer, Channel{
    update_channel_identity_flag: boolean /// allowe to update line or not
}

export interface CloneRegistrationUcid extends Channel{
    registration_application_channel: string // ucid 1_2312
    app_no:number,
    sub_channel:number,
    third_party?:string
}

export enum ResponseCodeRegistration{
    SUCCESS ='S20000',
    NOT_CREATE_NEW_PLATFORM = 'E40001',
    NOT_CREATE_REGISTRATION_SERVICE = 'E40003',
    NOT_CREATE_REGISTRATION_APPLICATION = 'E40005',
    NOT_UPDATE_LEAD_INSURE = 'E40006',
}

